import { registerConverter } from '@inwink/itemtemplate/bindingconverters';
import { toEntityLabel } from './toentitylabel';
import { toPriceLabel } from '@@components/itemtemplate/topricelabel';

export function registerAll(){
    registerConverter("toentitylabel", toEntityLabel);
    registerConverter("topricelabel", toPriceLabel);
}